module.exports = __webpack_public_path__ + "fonts/materialdesignicons-webfont.fc03f7f1.ttf";